import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent extends BaseClass<any> implements OnInit {

  public env = environment;

  constructor(
    public _common: CommonService,
    public _shared: SharedService,
    public service: WebserviceService,
    public router: Router
    ) { 
      super();
    }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }
  
  openLogin() {
    this._shared.emitLoginModal({ 'login': true });
  }

  confirmLogin(event_type_id: any, casino_id: any) {
    if (this.isLogin()) {
      this.router.navigate([`/casino-detail`, event_type_id, casino_id]);
    } else {
      this._common.openModalWithComponent('', LoginComponent, 'loginpopup')
    }
  }

}
